import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { BillsTableHeader } from './components/BillsTableHeader';
import { BILLS_TABLE_STYLES } from './styles';
import { IBillsTableProps } from './types';
import { BillsTableEmptyState } from './components/BillsTableEmptyState';
import { BillsTableBody } from './components/BillsTableBody';

export const BillsTable = ({ title, titleAddon, columns, testId, data, tableName, isLoading }: IBillsTableProps) => (
  <div data-testid={testId}>
    <div className={BILLS_TABLE_STYLES.TableTitle}>
      {title}
      {titleAddon && <span className={BILLS_TABLE_STYLES.TableTitleAddon}>{titleAddon}</span>}
    </div>
    <div>
      {/** @ts-ignore */}
      <table style={{ border: 0 }} className='w-full relative select-none bg-bw00' cellSpacing={0} cellPadding={0}>
        <colgroup>
          <col className='w-[145px]' />
          <col />
          <col className='w-[194px]' />
          <col className='w-[207px]' />
          <col className='w-[94px]' />
          <col className='w-[142px]' />
          <col className='w-[77px]' />
        </colgroup>
        <BillsTableHeader columns={columns} />
        {!isLoading && <BillsTableBody columns={columns} data={data} tableName={tableName} />}
      </table>
      {isLoading && (
        <div className='border border-bw03 border-t-[0] rounded-b-lg'>
          <Skeleton className='h-[64px] w-full' count={5} />
        </div>
      )}
      {!isLoading && data?.length === 0 && <BillsTableEmptyState tableName={tableName} />}
    </div>
  </div>
);
